import React from 'react'
import { Helmet } from 'react-helmet-async'

const Head = ({ title = '', description = '' } = {}) => (
  <Helmet title={title ? `${title} | E Approval System` : undefined} defaultTitle="E Approval System">
    <meta name="description" content={description} />
  </Helmet>
)

export default Head
